import { selectionCriteriaListTemplate } from "../models/SRPSchema";


const filterSelectionCriteriaByVehiclePrograms = (machineList, vehiclePrograms) => {
  const updatedMachineList = structuredClone(machineList);
  const indicesToKeep = [];
  
  for (let i = 0; i < updatedMachineList.length; i++) {
    indicesToKeep[i] = [];
    for (let j = 0; j < updatedMachineList[i].variantList.length; j++) {
      indicesToKeep[i][j] = [];
      for (let k = 0; k < updatedMachineList[i].variantList[j].clusterList.length; k++) {
        const clusterEntry = updatedMachineList[i].variantList[j].clusterList[k];
        const keptIndices = new Set();
        
        clusterEntry.selectionCriteriaList = clusterEntry.selectionCriteriaList.filter((criteria, index) => {
          const modelYearProgramCodeValue = `${criteria.modelYear}-${criteria.programCode}`;
          const shouldKeep = vehiclePrograms.includes(modelYearProgramCodeValue);
          if (shouldKeep) {
            keptIndices.add(index);
          }
          return shouldKeep;
        });
        
        indicesToKeep[i][j][k] = keptIndices;
      }
    }
  }
  
  return { updatedMachineList, indicesToKeep };
};

const updateErrorsBasedOnKeptIndices = (machineListErrors, indicesToKeep) => {
  const updatedMachineListErrors = structuredClone(machineListErrors);
  
  for (let i = 0; i < indicesToKeep.length; i++) {
    for (let j = 0; j < indicesToKeep[i].length; j++) {
      for (let k = 0; k < indicesToKeep[i][j].length; k++) {
        const clusterErrors = updatedMachineListErrors[i]?.variantListErrors?.[j]?.clusterListErrors?.[k];
        
        if (clusterErrors?.selectionCriteriaListErrors) {
          const keptIndices = indicesToKeep[i][j][k];
          clusterErrors.selectionCriteriaListErrors = clusterErrors.selectionCriteriaListErrors.filter((_, index) => 
            keptIndices.has(index)
          );
        }
      }
    }
  }
  
  return updatedMachineListErrors;
};

const addMissingVehicleProgramCriteria = (machineList, vehiclePrograms, machineListErrors) => {
  for (let i = 0; i < machineList.length; i++) {
    for (let j = 0; j < machineList[i].variantList.length; j++) {
      for (let k = 0; k < machineList[i].variantList[j].clusterList.length; k++) {
        const clusterEntry = machineList[i].variantList[j].clusterList[k];
        const existingModelYearProgramCode = new Set(
          clusterEntry.selectionCriteriaList.map(criteria => `${criteria.modelYear}-${criteria.programCode}`)
        );
        
        vehiclePrograms.forEach((vp) => {
          if (!existingModelYearProgramCode.has(vp)) {
            const [modelYear, programCode] = vp.split('-');
            clusterEntry.selectionCriteriaList.push({
              ...structuredClone(selectionCriteriaListTemplate),
              modelYear: modelYear,
              programCode: programCode,
            });

            if (!machineListErrors[i]?.variantListErrors?.[j]?.clusterListErrors?.[k]?.selectionCriteriaListErrors) {
              machineListErrors[i].variantListErrors[j].clusterListErrors[k].selectionCriteriaListErrors = [];
            }
            machineListErrors[i].variantListErrors[j].clusterListErrors[k].selectionCriteriaListErrors.push({});
          }
        });
      }
    }
  }
};


export function adjustSelectionCriteriaBasedOnVehiclePrograms(setMachineList: any, vehiclePrograms: any, setMachineListErrors: any) {
  setMachineList((prev) => {
    const { updatedMachineList, indicesToKeep } = filterSelectionCriteriaByVehiclePrograms(prev, vehiclePrograms);
    
    setMachineListErrors((prevErrors) => {
      const updatedMachineListErrors = updateErrorsBasedOnKeptIndices(prevErrors, indicesToKeep);
      addMissingVehicleProgramCriteria(updatedMachineList, vehiclePrograms, updatedMachineListErrors);
      return updatedMachineListErrors;
    });
    
    return updatedMachineList;
  });
}
